import { getCommonWidget } from "../../dashWidgetHelper";
import {
    PRODUTURO_PIE_COLORS, commonWidgets,
    getProfuturoFacilidad, getProfuturoNpsAcumulado,
    getProfuturoNpsPorMes, getProfuturoSatisfaccion,
    PRODUTURO_SCALE_5_COLORS, getProfuturoAtencion,
    getProfuturoCustomerJourney
} from "../commonWidgetsProfuturo";

export default {
    title: 'Acompañamiento Dashboard',
    description: 'Acompañamiento Dashboard',
    backgroundClassName: (filters: FiltersUI) => 'epsilon-hero-bg',
    widgets: (filters: FiltersUI) => [
        {
            title: 'Principales Indicadores',
            size: [4, 1],
            type: 'label',
            config: { color: '#B7AADC' },
        },
        getProfuturoNpsAcumulado({
            size: [1, 2],
            indicator: 'asistencia_directa_18'
        }),
        getProfuturoNpsPorMes({
            size: [1, 2],
            indicator: 'asistencia_directa_18',
            helpText: 'Para finalizar, en una escala del 0 al 10, a partir de tu último contacto con el Centro de Atención Telefónica, ¿qué tan probable es que recomiendes a Profuturo a tus amigos y familiares?'
        }),
        getProfuturoSatisfaccion({
            size: [1, 2],
            indicator: 'asistencia_directa_1',
            helpText: 'A partir de tu interacción con el portal web Profuturo ¿Qué tan satisfecho estás con las funciones y características disponibles?',
            extraConfigs: {
                colors: PRODUTURO_SCALE_5_COLORS
            }
        }),
        getProfuturoFacilidad({
            size: [1, 2],
            indicator: 'asistencia_directa_8',
            helpText: 'Considerando la asesoría brindada, ¿qué tan fácil te resultó resolver tu consulta/inquietud?',
            extraConfigs: {
                colors: PRODUTURO_SCALE_5_COLORS
            },
        }),
        getProfuturoAtencion({
              position: [3, 1],
              size: [1, 2],
              indicator: 'asistencia_directa_10',
              helpText: 'Ahora vamos a hablar de la atención que recibiste por parte del consultor telefónico. ¿Cómo fue tu experiencia?',
              extraConfigs: {
                 colors: PRODUTURO_SCALE_5_COLORS
             },
        }),
        getProfuturoCustomerJourney({
                id: 'cj-acompanamiento',
                size: [3, 2],
                indicators: [
                  { name: 'asistencia_directa_1', formula: 'count-number' }, //csat
                  { name: 'asistencia_directa_8', formula: 'count-number' }, //facilidad
                  { name: 'asistencia_directa_10', formula: 'count-number' }, //Atencion
                  { name: 'asistencia_directa_18', formula: 'nps-10' }, //nps
                ],
                title: 'Customer Journey: Top Two Box',
              }),    
            
        {
            title: 'Quiebres y Motivadores en la satisfacción',
            position: [0, 5],
            size: [4, 1],
            type: 'label',
            config: { color: '#B7AADC' },
        },
        getCommonWidget({
            commonWidgets: commonWidgets,
            name: 'pieGenericMedium',
            title: 'Satisfacción: clientes satisfechos',
            size: [2, 2],
            indicator: 'asistencia_directa_2',
            helpText: '¿Qué fue lo que más valoraste?',
            extraConfigs: {
                colors: PRODUTURO_PIE_COLORS,
                itemGap: 6,
                center: ['27%', '55%'],
            }
        }),

        getCommonWidget({
            commonWidgets: commonWidgets,
            name: 'pieGenericMedium',
            title: 'Satisfacción: clientes insatisfechos',
            size: [2, 2],
            indicator: 'asistencia_directa_4',
            helpText: '¿En qué podríamos mejorar?',
            extraConfigs: {
                colors: PRODUTURO_PIE_COLORS,
                itemGap: 6,
                center: ['27%', '55%'],
            }
        }),

       
        getCommonWidget({
            commonWidgets: commonWidgets,
            name: 'wordCount',
            title: 'Facilidad en la resolución',
            size: [2, 2],
            indicator: 'asistencia_directa_9',
            helpText: '¿Por qué te resultó de esa manera?'
        }),
        getCommonWidget({
            commonWidgets: commonWidgets,
            name: 'pieGenericMedium',
            title: 'Atención: clientes insatisfechos',
            size: [2, 2],
            indicator: 'asistencia_directa_11',
            helpText: '¡Queremos mejorar! Señalaste que la atención fue mala, ¿nos puedes contar por qué?',
            extraConfigs: {
                colors: PRODUTURO_PIE_COLORS,
                itemGap: 6,
                center: ['27%', '55%'],
            }
        }),

        getCommonWidget({
            commonWidgets: commonWidgets,
            name: 'pieGenericMediumSiNo',
            title: 'Utilidad del servicio',
            size: [2, 2],
            helpText: 'A partir de la asesoría brindada ¿Te resultó útil este servicio?',
            indicator: 'asistencia_directa_6',
            extraConfigs: {
                itemGap: 10,
                center: ['27%', '55%'],
            }
        }),

         getCommonWidget({
            commonWidgets: commonWidgets,
            name: 'wordCount',
            title: 'Razones de no utilidad',
            size: [2, 2],
            indicator: 'asistencia_directa_7',
            helpText: 'Lamentamos escuchar que no te haya resultado útil. ¿Nos podrías contar por qué?'
        }),

         {
            title: 'Atributos en la experiencia de Grado de SATISFACCIÓN',
            size: [4, 1],
            type: 'label',
        },
        getCommonWidget({
            commonWidgets: commonWidgets,
            name: 'stackedBar',
            title: 'La amabilidad y calidez de la persona que me atendió',
            size: [4, 1],
            helpText: '¿Qué tan satisfecho estás con cada uno de los siguientes aspectos?',
            indicator: 'asistencia_directa_14',
            extraConfigs: {
                colors: PRODUTURO_SCALE_5_COLORS
            },
        }),
        getCommonWidget({
            commonWidgets: commonWidgets,
            name: 'stackedBar',
            title: 'Los conocimientos y claridad con el que fui atendido acerca de mi consulta / trámite',
            size: [4, 1],
            helpText: '¿Qué tan satisfecho estás con cada uno de los siguientes aspectos?',
            indicator: 'asistencia_directa_15',
            extraConfigs: {
                colors: PRODUTURO_SCALE_5_COLORS
            },
        }),
        getCommonWidget({
            commonWidgets: commonWidgets,
            name: 'stackedBar',
            title: 'El compromiso e interés que se mostró para resolver mi consulta / trámite',
            size: [4, 1],
            helpText: '¿Qué tan satisfecho estás con cada uno de los siguientes aspectos?',
            indicator: 'asistencia_directa_16',
            extraConfigs: {
                colors: PRODUTURO_SCALE_5_COLORS
            },
        }),
        getCommonWidget({
            commonWidgets: commonWidgets,
            name: 'stackedBar',
            title: 'La asesoría que me dieron (orientación) para que tomara una decisión informada',
                  size: [4, 1],
            helpText: '¿Qué tan satisfecho estás con cada uno de los siguientes aspectos?',
            indicator: 'asistencia_directa_17',
            extraConfigs: {
                colors: PRODUTURO_SCALE_5_COLORS
            },
        }),
        getCommonWidget({
            commonWidgets: commonWidgets,
            name: 'textAnalysis',
            title: 'Análisis de Sentimientos',
            size: [4, 4],
            indicator: 'SENTIMENT'
        }),

    ]
} as DasboardConfig
